import { useQuery } from "@tanstack/react-query";
import { useAnalyticsModalContext } from "PFApp/analytics/parts/top_actions_panel/analytics_modal_context_provider";
import { Template } from "PFApp/analytics/types/reports";

import { fetchTemplate } from "../../../../services/manage_reports";
import { queryKeys } from "../query_keys";

export const useGetTemplate = () => {
  const {
    state: {
      data: { templateId }
    }
  } = useAnalyticsModalContext();

  return useQuery<Template>(queryKeys.byTemplateId(templateId), async () => await fetchTemplate(templateId), {
    enabled: !!templateId
  });
};
